/** What the form says on its button: a pull request is a proposal, nothing changes until it is merged. */
const PROPOSAL_TYPES = ['standaarden', 'kwaliteit'];

export function submitText(templateType?: string) {
  return templateType && PROPOSAL_TYPES.includes(templateType) ? 'Open het voorstel' : 'Maak aan';
}

/** A pattern that only limits the length, such as `^.{1,150}$`, as that length. */
export function lengthLimit(pattern?: string) {
  const match = pattern ? /^\^\.\{1,(\d+)\}\$$/.exec(pattern) : null;
  return match ? Number(match[1]) : undefined;
}

/** The short message for a value that does not fit; the description below the field says how it should be. */
export function formatMessage(pattern: string) {
  const limit = lengthLimit(pattern);
  return limit ? `Hoogstens ${limit} tekens` : 'Volgt de vorm uit de uitleg hieronder';
}

/** A string default of the template, for the field to start with. */
export function stringDefault(value: unknown) {
  return typeof value === 'string' && value !== '' ? value : undefined;
}
